import React, { Fragment } from 'react';
import Imgix from 'react-imgix';
import Separator from '../../../shared/separator';
import { getImgCDNDomain } from '../../../../../domain/common';
import { useAppSelector } from '../../data/store';
import ArrowIcon from '../../../../../ui/svg/common/arrow';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';
import { getGeneralSearchUrl } from '../../../search-desktop/domain/search-provider';

const SearchResults = () => {
    const query = useAppSelector(store => store.root.query);
    const filtered = useAppSelector(store => store.root.filtered);
    const imgDomain = getImgCDNDomain();

    const sendClickGAEvent = (position: number, documentUrlPath: string) => {
        // q: {query} | pos: {position} | page: {distinationURL}
        // q: api | pos: 3 | page: /plugins/api-2500
        sendGAEvent('AutoCompleteClick', `q: ${ query.toLowerCase()} | pos: ${ position  + 1} | page: ${ documentUrlPath }`);
    };

    return (
        <div className="text-gray-500 flex-1 flex flex-col overflow-auto mx-4" style={{
            // paddingBottom: '100px',
        }}>
            {
                query.trim() !== '' && filtered.length === 0 && (
                    <p className="flex py-4 flex-1 justify-center mt-6">
                        No results found.
                        <a
                            href={ getGeneralSearchUrl(query) }
                            title=""
                            className="no-underline ml-2 font-medium">
                            Search all
                        </a>
                    </p>
                )
            }

            {
                filtered.length > 0 &&
                <>
                    {
                        filtered.map((item, i) => {

                            const absImgUrl = `${ imgDomain }${ item.tiny }`;

                            return (
                                <Fragment key={ `${ item.documentName }-${ i }` }>
                                    <a
                                        href={ item.documentUrlPath }
                                        onClick={ () => {
                                            sendClickGAEvent(i, item.documentUrlPath);
                                        }}
                                        className={ `flex items-center no-underline text-tiny text-gray-500 py-2 px-2 hover:bg-gray-150` }>

                                        <div className="mr-4">
                                            <Imgix
                                                src={ absImgUrl }
                                                width={ 140 }
                                                className="whsd__icon"
                                            />
                                        </div>

                                        <div>
                                            <p className="font-medium text-gray-700 mb-1">{ item.documentName }</p>
                                            <p className="w-ellipsis w-line-clamp-2 text-sm" dangerouslySetInnerHTML={{__html: item.documentPageDescription }} />
                                        </div>
                                    </a>

                                    <Separator />
                                </Fragment>
                            )
                        })
                    }

                    <p className="flex pb-6 mt-4">
                        <a
                            href={ getGeneralSearchUrl(query) }
                            title=""
                            className="no-underline font-medium flex items-center">
                            See more results
                            <ArrowIcon
                                width="8px"
                                color="#3452ff"
                                title="Arrow Right"
                                rotationAngle={ -90 }
                                classes="ml-2"
                            />
                        </a>
                    </p>
                </>
            }

        </div>
    )
};

export default SearchResults;